<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-10-22 18:10:22
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>定价管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">定价列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="费用类型">
                  <el-select
                    v-model="ruleForm.type"
                    placeholder="请选择类型"
                    style="margin-right: auto"
                  >
                    <el-option label="任务定价" value="0"></el-option>
                    <el-option label="临勤邀请奖励" value="1"></el-option>
                    <el-option label="公司邀请奖励" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="状态类型">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择类型"
                    style="margin-right: auto;"
                  >
                    <el-option label="停用" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="计费模式">
                  <el-select
                    v-model="ruleForm.model1"
                    placeholder="请选择模式"
                    style="margin-right: auto"
                  >
                    <el-option label="小时计费" :value="0"></el-option>
                    <el-option label="包月计费" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="职业">
                  <el-select
                    v-model="ruleForm.zhiye"
                    placeholder="请选择模式"
                    style="margin-right: auto"
                    @change="zhiyeChange"
                  >
                    <el-option label="全部" value="0"> </el-option>
                    <el-option
                      :label="item.title"
                      :value="item.id"
                      v-for="(item, index) in zhenshu"
                      :key="index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="职业等级">
                  <el-select
                    v-model="ruleForm.dengji"
                    placeholder="请选择职业等级"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="i.propDesc"
                      :value="i.propValue"
                      v-for="(i, i2) in jibie"
                      :key="i2"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="省">
                  <el-select
                    v-model="ruleForm.province"
                    placeholder="请选择省"
                    style="margin-right: auto"
                    @change="getcity2"
                  >
                    <el-option
                      v-for="(item, index) in city"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="城市">
                  <el-select
                    v-model="ruleForm.city"
                    placeholder="请选择城市"
                    style="margin-right: auto"
                  >
                    <el-option
                      v-for="(item, index) in city1"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="任务时间">
                  <el-select
                    v-model="ruleForm.hour"
                    placeholder="请选择时间"
                    style="margin-right: auto"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.propDesc"
                      :label="item.propDesc"
                      :value="item.propValue"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <TableScrollSlider :table-ref="$refs.scrollTable" />
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="省市" align="center" width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.provinceCode == 100000">全国</div>
              <div v-else>{{ scope.row.province }}-{{ scope.row.city }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employSceneName"
            label="用工场景"
            align="center"
          >
          </el-table-column>
          <el-table-column label="平台服务费" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.platformRatio * 100 }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="保安公司成本比例" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.bodyguardCompanyCostRate * 100 }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="保安补贴" align="center" width="100">
            <template slot-scope="scope">
              <span>￥{{ scope.row.bodyguardSubsidy | moneyFormat }}</span>
            </template>
          </el-table-column>

          <el-table-column label="用户补贴" align="center" width="100">
            <template slot-scope="scope">
              <span>￥{{ scope.row.customSubsidy | moneyFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="保安费用" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 0"
                >￥{{ scope.row.bodyguardsPrice | moneyFormat }}</span
              >
              <span v-if="scope.row.type == 1"
                >{{ scope.row.invitationIncome }}%</span
              >
            </template>
          </el-table-column>
          <el-table-column label="用户费用" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 0"
                >￥{{ scope.row.customPrice | moneyFormat }}</span
              >
              <span v-if="scope.row.type == 1">无</span>
            </template>
          </el-table-column>
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.type == 0
                  ? "任务定价"
                  : scope.row.type == 1
                  ? "临勤邀请奖励"
                  : "公司邀请奖励"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="职业" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.careerTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="级别" align="center" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.levelTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="计费模式" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.billingModeName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="hour" label="时间" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">无</span>
              <span v-if="scope.row.type == 0 && scope.row.hour >= 1"
                >{{ scope.row.hour }}小时</span
              >
              <span v-if="scope.row.type == 0 && scope.row.hour < 1"
                >30分钟</span
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="publishTime"
            label="发布时间"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">停用</span>
              <span class="greenColor" v-if="scope.row.status == 1">启用</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="180"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  停用
                </div>
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="定价分类" prop="type">
          <el-select v-model="ruleForm1.type" placeholder="请选择">
            <el-option label="任务定价" value="0"> </el-option>
            <el-option label="临勤邀请奖励" value="1"> </el-option>
            <el-option label="公司邀请奖励" value="2"> </el-option>
          </el-select>
        </el-form-item>
        <div v-if="ruleForm1.type == '0'">
          <el-form-item label="计费模式" prop="model">
            <el-select v-model="ruleForm1.model" placeholder="请选择">
              <el-option label="包月计费" value="0"> </el-option>
              <el-option label="小时计费" value="1"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职业设定" prop="zhiye">
            <el-select
              v-model="ruleForm1.zhiye"
              placeholder="请选择"
              @change="zhiyeChange"
            >
              <el-option label="全部" value="0"> </el-option>
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="(item, index) in zhenshu"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="级     别"
            prop="jibie"
            v-if="ruleForm1.zhiye != 0"
          >
            <el-select v-model="ruleForm1.jibie" placeholder="请选择">
              <el-option
                :label="i.propDesc"
                :value="i.propValue"
                v-for="(i, i1) in jibie"
                :key="i1"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务省" prop="type1">
            <el-select
              v-model="ruleForm1.type1"
              placeholder="请选择"
              style="margin-right: auto"
              @change="cityChange"
            >
              <el-option
                v-for="(item, index) in city"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="服务城市"
            prop="select"
            v-if="ruleForm1.type1 != '100000'"
          >
            <el-select
              v-model="ruleForm1.select"
              placeholder="请选择"
              style="margin-right: auto"
            >
              <el-option
                v-for="(item, index) in city1"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item
          :label="ruleForm1.type == '1' ? '临勤邀请收益' : '公司邀请临勤'"
          prop="num"
          v-if="ruleForm1.type == '1' || ruleForm1.type == '2'"
        >
          <el-input v-model="ruleForm1.num" placeholder="请输入" type="number"
            ><template slot="append">%</template></el-input
          >
        </el-form-item>
        <div v-if="ruleForm1.type == '0'">
          <el-form-item label="场景" prop="employScene">
            <el-select v-model="ruleForm1.employScene" placeholder="请选择">
              <el-option
                v-for="item in tableData1"
                :key="item.title"
                :label="item.title"
                :value="item.propValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="定价时间" prop="time">
            <el-select v-model="ruleForm1.time" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.propDesc"
                :label="item.propDesc"
                :value="item.propValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="保安身高" prop="height">
            <el-select v-model="ruleForm1.height" placeholder="请选择">
              <el-option
                v-for="item in heightList"
                :key="item.propDesc"
                :label="item.propDesc"
                :value="item.propValue"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="用户补贴" prop="subsidy">
            <el-input
              :value="ruleForm1.subsidy"
              placeholder="请输入用户补贴"
              type="number"
              @input="getPrice1"
              ><template slot="append">￥</template></el-input
            >
          </el-form-item>
          <el-form-item label="保安补贴" prop="subsidy1">
            <el-input
              :value="ruleForm1.subsidy1"
              placeholder="请输入保安补贴"
              @input="getPrice2"
              type="number"
              ><template slot="append">￥</template></el-input
            >
          </el-form-item>
          <el-form-item label="用户费用" prop="customPrice">
            <el-input
              :value="ruleForm1.customPrice"
              placeholder="请输入用户费用"
              type="number"
              @input="getPrice"
              ><template slot="append">￥</template></el-input
            >
          </el-form-item>
          <el-form-item label="平台服务费" prop="proportion1">
            <el-input
              v-model="ruleForm1.proportion1"
              placeholder="请输入平台服务费"
              type="number"
              @input="getPrice3"
              ><template slot="append">%</template></el-input
            >
          </el-form-item>
          <el-form-item
            label="保安公司成本比例"
            prop="bodyguardCompanyCostRate"
          >
            <el-input
              v-model="ruleForm1.bodyguardCompanyCostRate"
              placeholder="请输入保安公司成本比例"
              type="number"
              @input="getPrice4"
              ><template slot="append">%</template></el-input
            >
          </el-form-item>
          <el-form-item label="保安定价" prop="bodyguardsPrice">
            <div>{{ priceInfo.bodyguardsPrice || 0 }}</div>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        hour: "",
        status: "",
        province: "",
        city: "",
        zhiye: "",
        dengji: "",
        type: "",
        model1: "",
      },
      tableData: [],
      tableData1: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "新增定价",
      ruleForm1: {
        type: "0",
        type1: "",
        time: "",
        customPrice: "",
        num: "",
        zhiye: "1",
        jibie: "",
        select: "",
        proportion1: "",
        subsidy: "",
        employScene: "",
        subsidy1: "",
        model: "1",
        bodyguardCompanyCostRate: "",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        customPrice: [{ required: true, message: "必填项", trigger: "blur" }],
        num: [{ required: true, message: "必填项", trigger: "blur" }],
        proportion1: [{ required: true, message: "必填项", trigger: "blur" }],
        employScene: [{ required: true, message: "必填项", trigger: "blur" }],
        subsidy: [{ required: true, message: "必填项", trigger: "blur" }],
        bodyguardCompanyCostRate: [
          { required: true, message: "必填项", trigger: "blur" },
        ],
        subsidy1: [{ required: true, message: "必填项", trigger: "blur" }],
        zhiye: [{ required: true, message: "必选项", trigger: "change" }],
        jibie: [{ required: true, message: "必选项", trigger: "change" }],
        model: [{ required: true, message: "必选项", trigger: "change" }],
        type1: [{ required: true, message: "必选项", trigger: "blur" }],
        select: [{ required: true, message: "必选项", trigger: "blur" }],
        time: [{ required: true, message: "必选项", trigger: "blur" }],
      },
      editId: "",
      options: [],
      city: [],
      city1: [],
      heightList: [],
      zhenshu: [],
      jibie: [],
      priceInfo: {},
      proportion: "",
    };
  },
  mounted() {
    this.getList();
    this.getTime1();
    this.getcity();
    this.getemployScene();
    this.getData();
    let obj = JSON.parse(localStorage.getItem("form")) || "";
    if (obj != "" && obj != null) {
      this.ruleForm1 = obj;
    }
  },
  methods: {
    hasMoreThanTwoDecimals(input) {
      let str = "";
      if (typeof input === "number") {
        str = input.toString();
      } else if (typeof input === "string") {
        str = input.trim();
      } else {
        return false;
      }

      const num = parseFloat(str);
      if (isNaN(num)) return false;

      const parts = str.split(".");
      return parts.length === 2 && parts[1].length > 2;
    },
    getemployScene() {
      this.$axios
        .post(`/admapi/employscene/list`)
        .then(({ data }) => {
          this.tableData1 = data;
        })
        .catch()
        .finally();
    },
    getJibie(val) {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: val,
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.jibie = data.items;
          if (this.ruleForm1.zhiye == this.zhenshu[0].id) {
            this.ruleForm1.jibie = data.items[data.items.length - 1].propValue;
          }
        })
        .catch()
        .finally();
    },
    getData() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_occupation",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.zhenshu = JSON.parse(data.items[0].propValue);
        })
        .catch()
        .finally();
    },
    zhiyeChange(val) {
      this.ruleForm1.jibie = "";
      this.ruleForm.dengji = "";
      for (var i = 0; i < this.zhenshu.length; i++) {
        if (val == this.zhenshu[i].id) {
          this.getJibie(this.zhenshu[i].lvKey);
        }
      }
    },
    getPrice3(val) {
      if (this.hasMoreThanTwoDecimals(val) == true) {
        this.$message({
          message: "输入的价格系统只精确小数点后两位，请重新输入",
          type: "warning",
        });
        return;
      }
      this.$set(this.ruleForm1, "proportion1", val);
      if (this.ruleForm1.customPrice == "") {
        return;
      }
      if (this.ruleForm1.proportion1 == "") {
        return;
      }
      let param = {
        customPrice: this.ruleForm1.customPrice,
        platformRatio: this.ruleForm1.proportion1 / 100,
      };
      this.$axios
        .post(`/admapi/setprice/getbodyguardprice`, param)
        .then(({ data }) => {
          this.priceInfo = data;
        })
        .catch()
        .finally();
    },
    getPrice4(val) {
      if (this.hasMoreThanTwoDecimals(val) == true) {
        this.$message({
          message: "输入的价格系统只精确小数点后两位，请重新输入",
          type: "warning",
        });
        return;
      }
      this.$set(this.ruleForm1, "platformServiceFeeRatio", val);
    },
    getPrice(val) {
      if (this.hasMoreThanTwoDecimals(val) == true) {
        this.$message({
          message: "输入的价格系统只精确小数点后两位，请重新输入",
          type: "warning",
        });
        return;
      }
      this.$set(this.ruleForm1, "customPrice", val);
      if (this.ruleForm1.customPrice == "") {
        return;
      }
      if (this.ruleForm1.proportion1 == "") {
        return;
      }
      let param = {
        customPrice: this.ruleForm1.customPrice,
        platformRatio: this.ruleForm1.proportion1 / 100,
      };
      this.$axios
        .post(`/admapi/setprice/getbodyguardprice`, param)
        .then(({ data }) => {
          this.priceInfo = data;
        })
        .catch()
        .finally();
    },
    getPrice1(val) {
      if (this.hasMoreThanTwoDecimals(val) == true) {
        this.$message({
          message: "输入的价格系统只精确小数点后两位，请重新输入",
          type: "warning",
        });
        return;
      } else {
        this.$set(this.ruleForm1, "subsidy", val);
      }
    },
    getPrice2(val) {
      if (this.hasMoreThanTwoDecimals(val) == true) {
        this.$message({
          message: "输入的价格系统只精确小数点后两位，请重新输入",
          type: "warning",
        });
        return;
      } else {
        this.$set(this.ruleForm1, "subsidy1", val);
      }
    },
    getcity() {
      let param = {
        type: 0,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city = data;
          if (this.ruleForm1.type1 != "" && this.ruleForm1.type1 != "100000") {
            this.getcity1();
          }
        })
        .catch()
        .finally();
    },
    cityChange() {
      if (this.ruleForm1.type1 == "100000") {
        this.ruleForm1.select = "";
      }
      if (this.ruleForm1.type1 != "" && this.ruleForm1.type1 != "100000") {
        this.getcity1();
      }
    },
    getcity1() {
      let param = {
        type: 1,
        adcode: this.ruleForm1.type1,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city1 = data;
        })
        .catch()
        .finally();
    },
    getcity2() {
      let param = {
        type: 1,
        adcode: this.ruleForm.province,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city1 = data;
        })
        .catch()
        .finally();
    },
    resetForm() {
      this.ruleForm.hour = "";
      this.ruleForm.status = "";
      this.ruleForm.province = "";
      this.ruleForm.city = "";
      this.ruleForm.zhiye = "";
      this.ruleForm.dengji = "";
      this.ruleForm.type = "";
      this.ruleForm.model1 = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleChange(val) {
      this.ruleForm.type = val[val.length - 1];
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.type != "") {
        param.queryParams.push({
          name: "type",
          type: "select",
          values: [{ itemKey: this.ruleForm.type }],
        });
      }
      // if (this.ruleForm.status != "") {
      //   param.queryParams.push({
      //     name: "type",
      //     type: "select",
      //     values: [{ itemKey: this.ruleForm.status }]
      //   });
      // }
      if (this.ruleForm.model1 != "") {
        param.queryParams.push({
          name: "billing_mode",
          type: "select",
          values: [{ itemKey: this.ruleForm.model1 }],
        });
      }
      if (this.ruleForm.zhiye != "") {
        param.queryParams.push({
          name: "career_type",
          type: "select",
          values: [{ itemKey: this.ruleForm.zhiye }],
        });
      }
      if (this.ruleForm.dengji != "") {
        param.queryParams.push({
          name: "level_type",
          type: "select",
          values: [{ itemKey: this.ruleForm.dengji }],
        });
      }
      if (this.ruleForm.province != "") {
        param.queryParams.push({
          name: "province_code",
          type: "select",
          values: [{ itemKey: this.ruleForm.province }],
        });
      }
      if (this.ruleForm.city != "") {
        param.queryParams.push({
          name: "city_code",
          type: "select",
          values: [{ itemKey: this.ruleForm.city }],
        });
      }
      if (this.ruleForm.hour != "") {
        param.queryParams.push({
          name: "hour",
          type: "select",
          values: [{ itemKey: this.ruleForm.hour }],
        });
      }
      this.$axios
        .post(`/admapi/setprice/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    stop(val) {
      this.$confirm(val.status == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/setprice/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 1 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/setprice/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    add() {
      this.ruleForm1.type = "0";
      this.ruleForm1.model = "1";
      this.ruleForm1.type1 = "";
      this.ruleForm1.select = "";
      this.ruleForm1.employScene = "";
      this.ruleForm1.time = "";
      this.ruleForm1.subsidy = "";
      this.ruleForm1.subsidy1 = "";
      this.ruleForm1.customPrice = "";
      this.ruleForm1.proportion1 = "";
      this.ruleForm1.bodyguardCompanyCostRate = "";
      this.ruleForm1.num = "";
      this.editId = "";
      this.bodyguardsPrice = "";
      this.customPrice = "";
      this.priceInfo = "";
      this.getProportion();
      this.getCostRate();
      this.getemployScene();
      this.ruleForm1.zhiye = this.zhenshu[0].id;
      this.getJibie(this.zhenshu[0].lvKey);
      this.dialogFormVisible = true;
      this.$refs.ruleForm.clearValidate();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            type: this.ruleForm1.type,
          };
          if (this.ruleForm1.type == 0) {
            param.hour = this.ruleForm1.time;
            param.bodyguardSubsidy = this.ruleForm1.subsidy1;
            param.customSubsidy = this.ruleForm1.subsidy;
            param.employScene = this.ruleForm1.employScene;
            param.platformRatio = this.ruleForm1.proportion1 / 100;
            param.customPrice = this.ruleForm1.customPrice;
            param.careerType = this.ruleForm1.zhiye;
            param.cityCode = this.ruleForm1.select;
            param.levelType = this.ruleForm1.jibie;
            param.provinceCode = this.ruleForm1.type1;
            param.bodyguardCompanyCostRate =
              this.ruleForm1.bodyguardCompanyCostRate / 100;
            param.invitationIncome = 0;
          } else {
            param.bodyguardCompanyCostRate =
              this.ruleForm1.bodyguardCompanyCostRate / 100;
            param.invitationIncome = this.ruleForm1.num / 100;
            param.bodyguardSubsidy = 0;
            param.customSubsidy = 0;
            param.platformRatio = this.ruleForm1.proportion1 / 100;
            param.employScene = "";
            param.cityCode = 100000;
            param.provinceCode = 100000;
          }
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/setprice/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.ruleForm1.customPrice = "";
                this.priceInfo = {};
                localStorage.setItem("form", JSON.stringify(this.ruleForm1));
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
              });
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/setprice/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    getTime1() {
      let param = {
        key: "setPriceTime",
        orderColumn: "prop_value",
        isAsc: 1,
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.options = data;
        })
        .catch()
        .finally();
    },
    getProportion() {
      let param = {
        key: "platformServiceFeeRatio",
        orderColumn: "prop_value",
        isAsc: 1,
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.proportion = data;
          this.$set(this.ruleForm1, "proportion1", data[0].propValue * 100);
        })
        .catch()
        .finally();
    },
    getCostRate() {
      let param = {
        key: "bodyguardCompanyCostRate",
        orderColumn: "prop_value",
        isAsc: 1,
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.proportion = data;
          this.$set(
            this.ruleForm1,
            "bodyguardCompanyCostRate",
            data[0].propValue * 100
          );
        })
        .catch()
        .finally();
    },
    getHeight() {
      let param = {
        key: "pricePremiumType_height",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          console.log(data);
          this.heightList = data;
        })
        .catch()
        .finally();
    },
    handleEdit(val) {
      this.editId = val.id;
      this.ruleForm1.type = JSON.stringify(val.type);
      this.ruleForm1.model = val.billingMode.toString();
      this.ruleForm1.zhiye = val.careerType.toString();
      this.ruleForm1.jibie = val.levelType.toString();
      this.ruleForm1.type1 = val.provinceCode;
      this.ruleForm1.select = val.cityCode;
      this.ruleForm1.employScene = val.employScene;
      this.ruleForm1.time = JSON.stringify(val.hour);
      this.ruleForm1.subsidy = val.customSubsidy;
      this.ruleForm1.subsidy1 = val.bodyguardSubsidy;
      this.ruleForm1.customPrice = val.customPrice;
      this.ruleForm1.proportion1 = val.platformRatio * 100;
      this.ruleForm1.bodyguardCompanyCostRate =
        val.bodyguardCompanyCostRate * 100;
      this.ruleForm1.num = val.invitationIncome * 100;
      if (val.type == 0) {
        this.getPrice(val.customPrice);
        this.getcity();
        for (var i = 0; i < this.zhenshu.length; i++) {
          if (val.careerType == this.zhenshu[0].id) {
            this.getJibie(this.zhenshu[0].lvKey);
          }
        }
      }
      this.dialogFormVisible = true;
      this.$refs.ruleForm.clearValidate();
    },
  },
};
</script>
<style scoped></style>
